const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de creación recepciones',
  PAGE_DESCRIPTION:
    'En este apartado puedes crear recepciones de productos. Crear recepciones de productos es importante porque de no hacerlo, los productos que tengas dados de alta no apareceran en inventario.'
};

export default HELPER_TEXTS;
